// @ts-nocheck
import { useState, useRef, useReducer, useEffect } from 'react';
import { Dialog } from "primereact/dialog";
import { Card } from 'primereact/card';
import { Toast } from 'primereact/toast';
import { Divider } from 'primereact/divider';
import { SlideMenu } from 'primereact/slidemenu';
import { Fieldset } from 'primereact/fieldset';
import "../assets/functionalComponents/_dialog.scss"
import "../assets/functionalComponents/_dataItem.scss"
import "../assets/functionalComponents/ScrollPanelDemo.css"

export const ModelWalkComponents = (props) => {
    const toast = useRef(null);
    const [, forceUpdate] = useReducer(num => num + 1, 0);
    const [layerList, setLayerList] = useState([]);
    const [indexNum, setIndexNum] = useState(null);

    useEffect(() => {
        let layers = window.LAYER_GROUP_3DMODEL.LAYER;
        let list = layerList;
        let count = 0;
        // 透過原始3D圖層列表匯入成SlideMenu
        layers.forEach((layer) => {
            if (layer.TYPE === "PhotogrammetryModel") {
                layer.index = count;
                layer.label = layer.TITLE;
                layer.viewType = null;
                layer.entity = null;
                // 設定展現傾斜攝影的圖層函式
                layer.command = () => { setIndexNum(layer.index) };
                layer.items = [
                    // 設定label名稱及展現方式函式
                    { label: '第一人稱', command: () => { FirstPersonView(layer.index) } },
                    { label: '第三人稱', command: () => { ThirdPersonView(layer.index) } },
                    { label: '面板模式', command: () => { Panel(layer.index) } },
                ];
                list.push(layer);
                count++;
            }
        })
        setLayerList(list);
    }, [])

    useEffect(() => {

        if (indexNum === null) return;

        layerList.forEach((layer) => {
            // 若變更展現的圖層則將曾添加過的圖層移除
            if (layer.layerObject && layer.layerObject !== null) {
                window.main.OView.removeLayer(layer.layerObject);
                layer.layerObject = null;
            }
        })

        let layer = layerList[indexNum];
        window.main.OView.addPhotogrammetryModelLayer({
            url: window.TERRAIN_SERVER.URL,
            identifier: layer.ID,
            urlTemplate: window.TERRAIN_SERVER.URLTemplate,
            token: window.TERRAIN_SERVER.TOKEN,
            callback: (e, PhotogrammetryModel) => {
                if (e) {
                    layer.layerObject = PhotogrammetryModel;
                    PhotogrammetryModel.goto();
                    toast.current.show({ severity: 'success', summary: '圖層資訊', detail: '已開啟圖層：' + layer.TITLE });
                    let drawTerrainSetting = window.main.OView.drawTerrainSetting;
                    drawTerrainSetting.noElevation = true;
                    window.main.OView.drawTerrainSetting = drawTerrainSetting;
                    forceUpdate();
                    return;
                }
                else if (!e) {
                    toast.current.show({ severity: 'error', summary: '圖層資訊', detail: '開啟圖層失敗：' + layer.TITLE });
                    forceUpdate();
                    return;
                }
            }
        });
        // 設定展現方式
        layer.viewType = null;
        forceUpdate();

    }, [indexNum])

    // 設定第一人稱展示
    const FirstPersonView = (index) => {

        let layer = layerList[index];

        if (layer.viewType === 0) return;

        window.main.OView.setMoveMode(ov.MOVE_TYPE.TERRAIN_WALK, {
            heightAboveGround: 1.8,
            keyboardMoveRate: 0.25,
            considerModel: true,
            standDetectFrustumHeight: -0.8,
            collisionDetectFrustumHeight: -1.5,
            collisionDetectRange: 0.5,
            mouseRotateRate: 1.5,
            keyboardRotateRate: 3
        })

        layer.viewType = 0;
        forceUpdate();
    }

    // 設定第三人稱展示
    const ThirdPersonView = (index) => {

        let layer = layerList[index];

        if (layer.viewType === 1) return;

        let custom = window.main.OView.findLayer("custom");
        if (custom === null) {
            custom = window.main.OView.addCustomLayer({
                layername: "custom"
            });
        }

        let centerPoint = layer.layerObject.boundary.Center;

        if(layer.entity === null) {

            
            let person = custom.addGLTFEntity({
                src: "./Person.glb",
                position: new Geo3DPoint(centerPoint.x, centerPoint.y, 500),
                minRange: 0
            });
    
            layer.entity = person;
        }

        window.main.OView.setMoveMode(ov.MOVE_TYPE.THIRD_PERSON_VIEW, {
            focusPoint: window.main.OView.windowToTerrain(centerPoint),
            maxDistence: 200,
            fixSpeed: true,
            heightAboveGround: 1.8,
            moveSpeed: 5,
            considerModel: true,
            standDetectFrustumHeight: 1,
            collisionDetectFrustumHeight: 0.3,
            collisionDetectRange: 0.5,
            glTFModel: layer.entity,
            glTFModelFunction: glTFFunction
        });
        layer.viewType = 1;
        forceUpdate();
    }

    const glTFFunction = (glTF, position, speed, rotate) => {
        // FocusPoint = position;
        glTF.update({ position: position });
        glTF.play(0);
        glTF.play(1);
        glTF.play(2);
        let list = glTF.getAnimationList();

        //speed為理論值速度，以fps60計算，單位m/s
        let weight = speed / 2;
        weight = weight > 1 ? 1 : weight;

        //調整動畫的撥放權重
        glTF.setAnimationWeight(0, weight);
        glTF.setAnimationWeight(1, 0);
        glTF.setAnimationWeight(2, 1 - weight);
        if (list.length !== 0) {
            //同時撥放數個動畫建議調整撥放速度，使每個動畫撥放一次循環時間相同
            glTF.setPlaySpeed(0, list[0].cycleTime);
            glTF.setPlaySpeed(1, list[1].cycleTime);
            glTF.setPlaySpeed(2, list[2].cycleTime);
        }
    }

    // 設定面板模式
    const Panel = (index) => {
        let layer = layerList[index];
        window.main.OView.setMoveMode(ov.MOVE_TYPE.PANEL);
        layer.viewType = 2;
        forceUpdate();
    }

    let layer = layerList[indexNum];

    return (
        <div>
            <Toast ref={toast} />
            <Dialog header="模型行走模擬" visible={props.ModelWalk} modal={false} keepInViewport={false} onHide={() => props.onHide('ModelWalk')} style={{ width: "25%" }}>
                <Card>
                    <p>請選擇欲模擬圖層</p>
                    <SlideMenu model={layerList} style={{ width: "100%" }} menuWidth={470}></SlideMenu>
                </Card>
                <br></br>
                {
                    layer ? 
                    (

                        layer.viewType === null ?
                            null : layer.viewType === 0 ?
                                (
                                    <Fieldset legend="移動方式說明" toggleable>
                                        <div className="field grid">
                                            <label className="col-12 md:col-6">人物行走：</label>
                                            <label className="col-12 md:col-6">WASD</label> 
                                        </div>
                                        <Divider />
                                        <div className="field grid">
                                            <label className="col-12 md:col-6">離地高度：</label>
                                            <label className="col-12 md:col-6">QZ</label>
                                        </div>
                                        <Divider />
                                        <div className="field grid">
                                            <label className="col-12 md:col-6">旋轉視角：</label>
                                            <label className="col-12 md:col-6">方向鍵(滑鼠左鍵)</label>
                                        </div>
                                    </Fieldset>
                                )
                                : layer.viewType === 1 ?
                                    (
                                        <Fieldset legend="移動方式說明" toggleable>
                                            <div className="field grid">
                                                <label className="col-12 md:col-6">人物行走：</label>
                                                <label className="col-12 md:col-6">WASD</label> 
                                            </div>
                                            <Divider />
                                            <div className="field grid">
                                                <label className="col-12 md:col-6">人物順移：</label>
                                                <label className="col-12 md:col-6">滑鼠中鍵點擊</label> 
                                            </div>
                                            <Divider />
                                            <div className="field grid">
                                                <label className="col-12 md:col-6">視角遠近：</label>
                                                <label className="col-12 md:col-6">滑鼠滾輪滾動</label>
                                            </div>
                                            <Divider />
                                            <div className="field grid">
                                                <label className="col-12 md:col-6">旋轉視角：</label>
                                                <label className="col-12 md:col-6">方向鍵(滑鼠左鍵)</label>
                                            </div>
                                        </Fieldset>
                                    ) : 
                                    (
                                        <Fieldset legend="移動方式說明" toggleable>
                                            <div className="field grid">
                                                <label className="col-12 md:col-6">離地高度：</label>
                                                <label className="col-12 md:col-6">QZ</label>
                                            </div>
                                            <Divider />
                                            <div className="field grid">
                                                <label className="col-12 md:col-6">視角移動：</label>
                                                <label className="col-12 md:col-6">WASD(滑鼠左鍵)</label>
                                            </div>
                                            <Divider />
                                            <div className="field grid">
                                                <label className="col-12 md:col-6">旋轉視角：</label>
                                                <label className="col-12 md:col-6">方向鍵(滑鼠中鍵)</label>
                                            </div>
                                        </Fieldset>
                                    )
                    ) : null
                }
            </Dialog>
        </div>
    )
}
